<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.$store.commit("app/setWidth", window.screen.width);
    window.onresize = () => {
      this.$store.commit("app/setWidth", window.screen.width);
    };
  },
};
</script>
<style lang="less">
@import "./styles/common.less";
body {
  background: #f2f2f2;
}
.el-dialog__headerbtn {
  top: 10px;
}
.el-dialog__header {
  padding: 16px 20px 16px;
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
}
.el-dialog__title {
  color: #333;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
.dialog-footer .el-button {
  border-radius: 5px;
  color: white;
}
.el-message-box__header {
  padding: 10px 20px 10px;
}
.el-message-box {
  border: none;
}
.el-message-box__title,
.el-message-box__headerbtn .el-message-box__close {
  color: #606266;
  // color:white;
}
.el-message-box__headerbtn {
  top: 10px;
}
.el-dialog__headerbtn i {
  font-size: 26px;
}
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #333;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
input[type="password"]::-ms-reveal {
  display: none;
}
.el-radio__label {
  font-size: 14px;
}
.el-checkbox__label {
  font-size: 14px;
}
ul,
li {
  list-style-type: none;
}
.el-tabs__content {
  overflow: inherit;
}

.el-message--error {
  top: 51% !important;
}
.el-message--success {
  top: 51% !important;
}
.el-message--warning {
  top: 51% !important;
}
.el-message--info {
  top: 51% !important;
}
.el-input__inner {
  font-size: 14px;
}
.el-textarea__inner {
  font-size: 14px;
}
.el-pagination__sizes .el-input .el-input__inner {
  font-size: 14px;
}
.el-message-box__wrapper {
  .el-message-box__btns {
    text-align: right;
  }
}
.el-tree-node__label {
  font-size: 14px;
}
.el-select-dropdown__item {
  font-size: 14px;
}
</style>
